// -------------------------------------------------------------------------
// MARK: Default Data for Registration Account
// Needed to set default data for the registration account piece of state
// in order receipts page to be able to process information for display in
// CMS on both the registration and the receipt pages
// -------------------------------------------------------------------------
import * as formViews from "../common/AccountForm/constants/formViews";

// Initial registrationAccount state loaded on to the receipt page
const receiptPageInitialState = {
    registrationId: 12345,
    isFundraisingParticipant: true,
    global: {
        hasActiveGlobalAccount: false,
        isLoggedIn: true,
        hasSocialLogins: false,
    },
    contact: {
        firstName: "John Doe",
        email: "john_doe@test.com",
    },
    history: {
        hasLoggedInToThisEventBefore: false,
        isPreviousFundraiser: false,
        lastEventName: "",
    },
    urls: {
        participantAction: "",
        eventHome: "",
        myFundraisingDashboard: "",
        donorActionUrl: "",
    },
    form: {
        location: "Receipt",
        initialGlobalAccountAction: 2,
        uniqueIdentifier: "",
        formView: formViews.ACTIVATE_ACCOUNT,
        submitted: {},
        submittedMessage: {},
    },
};

// -------------------------------------------------------------------------
// NOTE: The keys that are available on the registrationAccount state in the
// initial state is different on the registration page than it is on the
// receipt page. However as there is no overlap in the value of these keys
// we are loading both of these keys simultaneously in this version of the
// default state. If this is problematic the easiest way to solve this
// problem in the future will probably be to load the same initial state
// into both pages so that we do not have to worry about managing the
// differences between the two.
// -------------------------------------------------------------------------
const registrationAccountDefaultValues = {
    registrationAccount: {
        ...receiptPageInitialState,
    },
};

export default registrationAccountDefaultValues;
